<template>
  <BModal
    ref="modalRef"
    :id="modalId"
    :title="modalTitle"
    :ok-only="mode === 'ok'"
    :size="modalSize"
    :centered="modalCentered"
    :dialog-class="modalDialogClass"
    :header-class="modalHeaderClass"
    :footer-class="modalFooterClass"
    :button-size="modalButtonSize"
    :ok-variant="modalOkVariant"
    :ok-title="modalOkTitle"
    :cancel-title="modalCancelTitle"
    @ok="onOk"
    @cancel="onCancel"
    @hidden="onHidden"
    no-header
  >
    <p class="word-pre-wrap mb-0" style="font-size: large;">{{ modalBody }}</p>
  </BModal>
</template>

<script setup>
import { ref, defineComponent } from 'vue'
import { BModal } from 'bootstrap-vue-next'

const props = defineProps({
  modalId: { type: String, required: true }
})
const emit = defineEmits(['confirmOk'])

const modalRef = ref(null)
const modalTitle = ref('')
const modalBody = ref('')
const mode = ref('ok') // 'ok' | 'confirm'

const modalSize = ref(undefined)
const modalCentered = ref(false)
const modalDialogClass = ref('')
const modalHeaderClass = ref('')
const modalFooterClass = ref('')
const modalButtonSize = ref(undefined)

const modalOkVariant = ref('primary')
const modalOkTitle = ref('OK')
const modalCancelTitle = ref('キャンセル')

const onHidden = () => {
  resolvePromise?.(false)
  resolvePromise = null
}

let resolvePromise = null

const applyOptions = (options = {}) => {
  modalTitle.value = options.title ?? modalTitle.value
  modalSize.value = options.size ?? 'sm'
  modalButtonSize.value = options.buttonSize
  modalOkVariant.value = options.okVariant ?? 'primary'
  modalOkTitle.value = options.okTitle ?? 'OK'
  modalCancelTitle.value = options.cancelTitle ?? 'キャンセル'
  modalCentered.value = options.centered ?? true
  modalDialogClass.value = options.dialogClass ?? ''
  modalHeaderClass.value = options.headerClass ?? 'p-2 border-bottom-0'
  modalFooterClass.value = options.footerClass ?? 'p-2 border-top-0'
}

const msgBoxOk = (msg, options = {}) => {
  console.log(options)
  mode.value = 'ok'
  modalBody.value = msg
  applyOptions(options)
  modalRef.value?.show()
  return new Promise((resolve) => { resolvePromise = resolve })
}

const msgBoxConfirm = (msg, options = {}) => {
  console.log(options)
  mode.value = 'confirm'
  modalBody.value = msg
  applyOptions(options)
  modalRef.value?.show()
  return new Promise((resolve) => { resolvePromise = resolve })
}

const onOk = () => {
  if (mode.value === 'confirm') emit('confirmOk')
  resolvePromise?.(true)
  resolvePromise = null
}

const onCancel = () => {
  resolvePromise?.(false)
  resolvePromise = null
}

defineExpose({ msgBoxOk, msgBoxConfirm })
</script>
<style>
.word-pre-wrap { white-space: pre-wrap; }
</style>
